import cn from '@/lib/cs';
import React from 'react';
import ArrowRightIcon from './ArrowRightIcon';

const ArrowLeftIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<ArrowRightIcon
		className={cn('rotate-180 -scale-y-100', className)}
		{...props}
	/>
);

export default ArrowLeftIcon;
